import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../../utils/api';
import { useAuthStore } from '../../store';

const cardStyle = { maxWidth: 420, margin: '3rem auto', padding: '1rem' };

export const LoginPage = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { setAuth } = useAuthStore();
  const navigate = useNavigate();
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleLogin = async () => {
    setLoading(true); setError('');
    try {
      const res = await authAPI.login(form);
      setAuth(res.data.user, res.data.token);
      navigate(res.data.user.role === 'admin' ? '/admin' : '/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={cardStyle}>
      <div className="card">
        <h1 style={{ fontSize: '1.5rem', fontWeight: 800, textAlign: 'center', marginBottom: '0.3rem' }}>Welcome Back 👋</h1>
        <p className="text-muted text-sm text-center" style={{ marginBottom: '1.5rem' }}>Sign in to your account</p>
        {error && <div className="alert alert-error">{error}</div>}
        <div className="form-group">
          <label className="form-label">Email</label>
          <input className="form-input" type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="you@email.com" />
        </div>
        <div className="form-group">
          <label className="form-label">Password</label>
          <input className="form-input" type="password" value={form.password} onChange={e => set('password', e.target.value)} />
        </div>
        <button className="btn btn-primary btn-full btn-lg" onClick={handleLogin} disabled={loading} style={{ marginTop: '0.5rem' }}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
        <p className="text-center text-sm" style={{ marginTop: '1rem' }}>
          Don't have an account? <Link to="/register" style={{ color: '#2563eb', fontWeight: 700 }}>Sign Up</Link>
        </p>
        <p className="text-center text-xs text-muted" style={{ marginTop: '0.5rem' }}>
          Admin: admin@schoolkit2go.com / admin123
        </p>
      </div>
    </div>
  );
};

export const RegisterPage = () => {
  const [form, setForm] = useState({ name: '', email: '', password: '', phone: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { setAuth } = useAuthStore();
  const navigate = useNavigate();
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleRegister = async () => {
    if (!form.name || !form.email || !form.password) { setError('All fields required'); return; }
    setLoading(true); setError('');
    try {
      const res = await authAPI.register(form);
      setAuth(res.data.user, res.data.token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={cardStyle}>
      <div className="card">
        <h1 style={{ fontSize: '1.5rem', fontWeight: 800, textAlign: 'center', marginBottom: '0.3rem' }}>Create Account 🎒</h1>
        <p className="text-muted text-sm text-center" style={{ marginBottom: '1.5rem' }}>Start shopping for your school supplies</p>
        {error && <div className="alert alert-error">{error}</div>}
        {['name', 'email', 'phone', 'password'].map(k => (
          <div className="form-group" key={k}>
            <label className="form-label">{k.charAt(0).toUpperCase() + k.slice(1)}{k !== 'phone' ? ' *' : ''}</label>
            <input className="form-input" type={k === 'password' ? 'password' : k === 'email' ? 'email' : 'text'} value={form[k]} onChange={e => set(k, e.target.value)} />
          </div>
        ))}
        <button className="btn btn-primary btn-full btn-lg" onClick={handleRegister} disabled={loading} style={{ marginTop: '0.5rem' }}>
          {loading ? 'Creating...' : 'Create Account'}
        </button>
        <p className="text-center text-sm" style={{ marginTop: '1rem' }}>
          Already have an account? <Link to="/login" style={{ color: '#2563eb', fontWeight: 700 }}>Sign In</Link>
        </p>
      </div>
    </div>
  );
};
